import { render, staticRenderFns } from "./dialog-keydetail.vue?vue&type=template&id=2d38af4a&"
import script from "./dialog-keydetail.vue?vue&type=script&lang=js&"
export * from "./dialog-keydetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports